import React, { FunctionComponent, ReactNode, useEffect } from 'react';
import { AuthHeader } from './AuthHeader';
import { AuthFooter } from './AuthFooter';
import '../../styles/auth.css';

interface AuthPageProps {
  children: ReactNode;
  pageTitle?: string;
  showLoginButton?: boolean;
  showSignupButton?: boolean;
}

export const AuthPage: FunctionComponent<AuthPageProps> = ({
  children,
  pageTitle,
  showLoginButton = false,
  showSignupButton = false
}) => {
  useEffect(() => {
    if (pageTitle) {
      document.title = pageTitle;
    }
  }, [pageTitle]);

  return (
    <div className="auth-page-wrapper">
      <AuthHeader
        showLoginButton={showLoginButton}
        showSignupButton={showSignupButton}
      />
      <main className="auth-content">
        {children}
      </main>
      <AuthFooter />
    </div>
  );
};

export default AuthPage;
